import { PropsWithChildren } from 'react'
import classnames from 'classnames'

export const StickyHeader = ({ children }: PropsWithChildren) => (
  <div className={classnames('sticky-header', 'mobile-sticky-header-visible')}>
    <div className="mobile-sticky-header-bounded-content">
      <div className="mobile-sticky-header-actions">{children}</div>
    </div>
  </div>
)
